import { ReduxUtils } from '../dependencies';

export const routePaths = ReduxUtils.strictObjectAccess({
    SIGN_IN: '/sign-in',
    SIGN_UP: '/sign-up',
});
